export default __webpack_public_path__ + "static/media/chuseok2.e07df408.jpg";